// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import { InputGroup, InputPhone } from '../../..';

// Styles
import './input-group-phone-cell.scss';

// Types
import { formikInjectedPropsTypes } from '../../../../../lib/validation/propTypes/formikPropTypes';

/**
 * @visibleName Phone
 */
const InputGroupPhoneCell = ({ className, inverse, formikProps, ...props }) => {
  return (
    <InputGroup
      {...props}
      className={classnames('input-group-phone', className)}
    >
      <InputPhone
        className="input-phone"
        name="phone"
        formikProps={formikProps}
      />
    </InputGroup>
  );
};

InputGroupPhoneCell.propTypes = {
  className: PropTypes.string,
  inverse: PropTypes.bool.isRequired,
  formikProps: formikInjectedPropsTypes.isRequired,
};

export default InputGroupPhoneCell;
